export default "__VITE_ASSET__f19a551e__"